export class ThrowError {
    static TITLE_DEFAULT = 'Olá'
    static MESSAGE_DEFAULT = 'Não foi possível concluir sua solicitação no momento'

    constructor() {}

    static create(message: String) {
        return btoa(JSON.stringify({
            message
        }))
    }

    static get(error: Error) {
        try {
            let aux = JSON.parse(atob(error.message))
            if (aux.message) {
                return aux.message
            }
        } catch (e) {
            return ThrowError.MESSAGE_DEFAULT
        }
    }
}